import React, { Fragment } from 'react';
import { routeCharacteristicsInformationPropTypes } from '../proptypes/RoutePropTypes';
import Checkbox from '../../../../common/forms/Checkbox';

const RouteCharacteristicsInformationResource = ({
  hotZone,
  coldZone,
  steepRoute,
  flatRoute,
  isLong,
}) => (
  <Fragment>
    <h3>Características</h3>
    <div>
      <Checkbox checked={hotZone} /> Zona Cálida
    </div>
    <div>
      <Checkbox checked={coldZone} /> Zona Fría
    </div>
    <div>
      <Checkbox checked={steepRoute} /> Ruta Empinada
    </div>
    <div>
      <Checkbox checked={flatRoute} /> Ruta Llana
    </div>
    <div>
      <Checkbox checked={isLong} /> Ruta Larga
    </div>
  </Fragment>
);

RouteCharacteristicsInformationResource.propTypes =
  routeCharacteristicsInformationPropTypes;

export default RouteCharacteristicsInformationResource;
